import { ReactElement } from 'react';
import { GetEnergyEfficiencyRating } from '~/pages/NewOverview/types';
import { ConstructionAreaInfo } from './components/ConstructionAreaInfo';
import { EnergyEfficiencyInfo } from './components/Table';

interface EnergyEfficiencyCardContentProps {
  data: GetEnergyEfficiencyRating | undefined;
  hasEnergy: boolean;
}

export function EnergyEfficiencyCardContent({
  data,
  hasEnergy,
}: Readonly<EnergyEfficiencyCardContentProps>): ReactElement {
  const disabled = !hasEnergy || !data;
  const hasConstructionArea = data?.HAS_BUILT_AREA;

  if (hasEnergy && !disabled && !hasConstructionArea) {
    return (<ConstructionAreaInfo />);
  }

  return (
    <EnergyEfficiencyInfo
      data={data?.RATING}
      disabled={disabled}
    />
  );
}
